<template>
  <div class="full-wrapper">
    <div class="associate-hero">
      <div class="a-hero-text text-center py-5">
        <div class="container">
          <h1 class="secondary-color page-intro-line fw-bold">
            Associate Partnership
          </h1>
          <h2 class="mb-5 px-5 main-heading-1" style="font-size: 2rem">
            We bring study abroad within the common man’s reach
          </h2>
          <!-- <p>
            Lorem ipsum dolor sit amet consectetur. Fames integer nunc lacus
            aliquet hendrerit <br />
            augue et. Imperdiet diam proin cursus arcu cursus nibh ante.
          </p> -->
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-7 custom_overflow" data-aos="fade-right" data-aos-duration="600">
              <img src="../../assets/imgs/associate-hero.png" alt="" class="my-3 img-fluid" />
            </div>
            <div id="newForm" class="col-lg-5 form_wrapper responsive_margin" data-aos="fade-left"
              data-aos-duration="600" style="
                border-radius: 10px;
                background-color: #fff;
                box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
              ">
              <form @submit.prevent="handleSubmitNewForm">
                <div class="custom-form-control my-2">
                  <div class="form-spacing text-left">
                    <label>Name:</label>
                    <input size="sm" required v-model="form.name" placeholder="Enter Name *" class="form-control" />
                  </div>

                  <div class="form-spacing text-left">
                    <label>Email:</label>
                    <input required size="sm" v-model="form.email" placeholder="Enter Email Address *"
                      class="form-control" />
                  </div>

                  <div class="form-spacing text-left">
                    <label>Phone Number:</label>
                    <input required size="sm" v-model="form.mobileNumber" placeholder="Enter Mobile Number *"
                      class="form-control" />
                  </div>
                  <div class="form-spacing text-left">
                    <label>Select State:</label>
                    <b-form-select required size="sm" v-model="form.state" :options="stateOptions"
                      class="form-control"></b-form-select>
                  </div>

                  <div class="form-spacing text-left">
                    <label>Select City:</label>
                    <b-form-select required size="sm" v-model="form.city" :options="cityOptions"
                      class="form-control"></b-form-select>
                  </div>
                  <!-- <b-form-select
                required
                size="sm"
                v-model="form.city"
                :options="cityOptions"
                class="form-control"
              ></b-form-select> -->

                  <div class="w-100 pt-4 pb-3 d-flex justify-content-start">
                    <button type="submit" class="btn rounded w-50" style="background-color: #fe6d01; color: white">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="a-cards pt-5 text-center">
      <div class="container">
        <h2 class="main-heading-1-gradient">Why Partner with Aliff</h2>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 gap-1 py-5">
          <div class="col-12 col-md-6 col-lg-4 mb-2" v-for="(card, index) in cards" :key="index">
            <div class="card text-center pt-3 a-card border-0">
              <img :src="card.image" alt="" class="mx-auto mb-3" width="50" />
              <div class="card-body text-center">
                <h3 class="m-0 mb-1 text-center">{{ card.preText }}</h3>
                <h1 class="card-title m-0 mb-1" style="font-weight: 900">
                  {{ card.title }}
                </h1>
                <h3 class="text-center m-0">
                  {{ card.postText }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section>
      <b-row class="d-flex justify-content-center">
        <div style="height: 800px; width: 100%">
          <img src="../../assets/imgs/associate-plans.png" alt=""
            style="object-fit: contain; height: 100%; width: 100%" />
        </div>
      </b-row>
    </section>
    <section class="pb-xl-5 mb-5 mx-lg-3">
      <div class="container">
        <h1 class="text-center font-bold mb-5">Exclusive For Your Students</h1>
        <b-row>
          <b-col v-for="(country, index) in countries" :key="index" cols="12" md="4">
            <b-card class="border-none" style="border: none">
              <b-card-img :src="country.Image" width="310px" height="146px" alt="Country flag"></b-card-img>
              <b-card-body>
                <b-card-title>{{ country.Country }}</b-card-title>
                <ul class="">
                  <li>
                    {{ country.text1 }}
                  </li>
                  <li>
                    {{ country.text2 }}
                  </li>
                </ul>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </section>
    <!-- <div class="a-plans py-5">
      <div class="container">
        <div class="a-plans-text text-center">
          <h2 class="main-heading-1-gradient">Associate plans</h2>
          <p class="w-50 m-auto">
            Our programs have the right edge to fit you’re your budget! When we
            plan our packages, your comfort pocket size is our main concern.
            This is the reason all our packages are tailor-made to suit your
            needs and it does have the sharp edge to lean your cost
            expectations.
          </p>
          <b-row class="row-cols-1 row-cols-md-2 row-cols-lg-3 mx-5 py-5">
            <b-col v-for="(pkg, index) in mydata" :key="index">
              <b-card class="text-center pricing-card a-card border-0">
                <div>
                  <h2 :style="{ color: pkg.color }">{{ pkg.title }}</h2>
                  <div class="price">
                    <h2
                      class="pricing-cost font-weight-bold"
                      style="font-size: 44px;"
                    >
                      {{ pkg.service_fee }}
                    </h2>
                    <div class="plan-box text-left">
                      <p class="font-weight-bold text-start text-capitalize">
                        {{ pkg.plan }}
                      </p>
                      <ul class="bullet-points p-0 pl-4">
                        <li
                          v-for="(point, pointIndex) in pkg.bullet_points"
                          :key="pointIndex"
                        >
                          {{ point }}
                        </li>
                      </ul>
                    </div>
                    <button
                      :class="getButtonClass(pkg.title)"
                      class="btn w-100"
                    >
                      <a target="_blank" :href="pkg.rzp_link" class="text-white"
                        >Pay Now</a
                      >
                    </button>
                  </div>
                  <div class="plan-route py-3" @click="clickShowPlan()">
                    View & Compare Plans
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </div> -->
    <section class="student-section pb-xl-5 my-5">
      <div class="container-fluid bg-row py-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <div class="main-heading-1">
              <!-- We make studying abroad a simple step for you! -->
              Partners Testimonials
            </div>
            <div class="main-content-1">
              <!-- Just climb higher without having to look at the cost. Our prices
              are customized to give you an edge without letting you feel any
              burden. -->
              <!-- Our programs have the right edge to fit you’re your budget! When
              we plan our packages, your comfort pocket size is our main
              concern. -->
            </div>
          </div>

          <div class="col-lg-12 mt-5 stu-card-section">
            <AssociateTestimonial :testimonialsData="testimonialData['partner']['testimonial-0']" />
          </div>
        </div>
      </div>
    </section>
    <section class="university-section section-spacing">
      <div class="container-fluid mb-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center" data-aos="fade-up" data-aos-duration="500">
            <h2 class="main-heading-1-gradient text-center">
              460+ Top Universities
            </h2>
            <!-- <p class="main-content-1">
              Global Education for Global Citizens of Tomorrow
              Our programs have the right edge to fit you’re your budget! When
              we plan our packages, your comfort pocket size is our main
              concern.
            </p> -->
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <slick ref="logoSlider" :options="logoSlider" class="logo-slider" v-if="featured_universities.length > 0">
              <div v-for="(university, index) in featured_universities" :key="'featured_universities_' + index">
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[0].university_logo" class="img-fluid" @click="(e) =>
                      $router.push({
                        name: 'UniversityAbout',
                        params: {
                          university_id: university[0].university_id,
                        },
                      })
                      " />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[1].university_logo" class="img-fluid" @click="(e) =>
                      $router.push({
                        name: 'UniversityAbout',
                        params: {
                          university_id: university[1].university_id,
                        },
                      })
                      " />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[2].university_logo" class="img-fluid" @click="(e) =>
                      $router.push({
                        name: 'UniversityAbout',
                        params: {
                          university_id: university[2].university_id,
                        },
                      })
                      " />
                  </div>
                </div>
              </div>
            </slick>
            <!-- <div class="text-center mt-5">
              <button
                @click="$router.push({ path: '/search/search' })"
                class="btn-secondary-red"
              >
                Explore Universities
              </button>
            </div> -->
          </div>
        </div>
      </div>

      <section class="container">
        <h2 class="main-heading-1-gradient text-center" data-aos="fade-down" data-aos-duration="600">
          19+ Countries Covered
        </h2>
        <div class="row desk-m p-lg-2 py-xl-4" role="tablist">
          <b-card no-body class="mb-1 col-xl-6 co-md-12" style="border: none">
            <button block v-b-toggle.accordion-1 variant="info" class="countries_btn">
              <!-- <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              /> -->
              North America
            </button>

            <!-- <b-collapse
              id="accordion-1"
              visible
              accordion="my-accordion"
              role="tabpanel"
            > -->
            <b-card style="margin-top: 10px">
              <ul class="state-list">
                <li>U.S.A</li>
                <li>Canada</li>
              </ul>
            </b-card>
            <!-- </b-collapse> -->
          </b-card>

          <b-card no-body class="mb-1 col-xl-6 co-md-12" style="border: none">
            <button block v-b-toggle.accordion-4 variant="info" class="countries_btn">
              <!-- <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              /> -->
              Middle East
            </button>

            <b-card style="margin-top: 10px">
              <ul class="state-list">
                <li>UAE</li>
                <li>Turkey</li>
              </ul>
            </b-card>

            <!-- <b-collapse
              id="accordion-4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <ul class="state-list">
                  <li>UAE</li>
                  <li>Turkey</li>
                </ul>
              </b-card-body>
            </b-collapse> -->
          </b-card>

          <b-card no-body class="mb-1 col-xl-6 co-md-12" style="border: none">
            <button block v-b-toggle.accordion-2 variant="info" class="countries_btn">
              <!-- <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              /> -->
              Europe
            </button>

            <!-- <b-collapse
              id="accordion-2"
              accordion="my-accordion"
              role="tabpanel"
            > -->
            <b-card style="margin-top: 10px">
              <div class="d-flex">
                <ul class="state-list">
                  <li>UK</li>
                  <li>Germany</li>
                  <li>Switzerland</li>
                  <li>France</li>
                </ul>
                <ul class="state-list">
                  <li>Ireland</li>
                  <li>Latvia</li>
                  <li>Spain</li>
                  <li>Russia</li>
                </ul>
                <ul class="state-list">
                  <li>Hungary</li>
                  <li>Georgia</li>
                </ul>
              </div>
            </b-card>
            <!-- </b-collapse> -->
          </b-card>

          <b-card no-body class="mb-1 col-xl-6 co-md-12" style="border: none">
            <button block v-b-toggle.accordion-3 variant="info" class="countries_btn">
              <!-- <img
                src="../../assets/imgs/svgs/FlowerVector.svg"
                alt=""
                class="flower_vector"
              /> -->
              Asia & Pacific
            </button>

            <!-- <b-collapse
              id="accordion-3"
              accordion="my-accordion"
              role="tabpanel"
            > -->
            <b-card style="margin-top: 10px">
              <ul class="state-list">
                <li>Australia</li>
                <li>New Zealand</li>
                <li>Singapore</li>
                <!-- <li>New Zealand</li> -->
                <li>Malaysia</li>
              </ul>
            </b-card>
            <!-- </b-collapse> -->
          </b-card>
        </div>
      </section>
      <!-- <img src="../../assets/imgs/a-ill.png" alt="" /> -->
    </section>
    <!-- <section class="pb-5">
      <div class="container">
        <div
          class="books-wrapper d-flex justify-content-center justify-content-lg-between align-items-center flex-column flex-lg-row "
        >
          <div class="text-center text-lg-left">
            <h2 class="main-heading-1-gradient text-center text-lg-left">
              About Aliff
            </h2>
            <p class="my-4">
              Aliff, established in 2008, has offices across India, UAE, Kuwait
              & the USA . Aliff has a counselling experience of 23k+ students.
              Our visa success ratio has been 98%. Aliff students have received
              scholarships of worth Rs 32+ Crore (US$ 3.7+ million) to study at
              prestigious universities.
            </p>
            <img
              src="../../assets/imgs/google-img.png"
              alt=""
              class="py-3 py-lg-0 img-fluid"
            />
          </div>
          <div>
            <img src="../../assets/imgs/a-books.png" alt="" class="img-fluid" />
          </div>
        </div>
      </div>
    </section> -->
    <section class="pb-xl-5 mb-5 mx-lg-3">
      <div class="container">
        <h2 class="main-heading-1-gradient text-center mb-5">
          Partners Contribution
        </h2>
        <b-row class="align-items-center row-cols-1 row-cols-lg-2">
          <b-col class="">
            <h3 class="mb-1 font-weight-bold">Top Programs</h3>
            <ul class="text-center">
              <li v-for="(list, index) in programs" :key="'a' + index" style="list-style-type: none; gap: 10px"
                class="d-flex align-items-center mb-1">
                <div class="dy-color" :style="{ background: list.color }"></div>
                {{ list.title }}
              </li>
            </ul>
          </b-col>
          <b-col>
            <img src="../../assets/imgs/a-chart.png" alt="" class="img-fluid" />
          </b-col>
        </b-row>
      </div>
    </section>
    <!-- <section>
      <div class="container">
        <div class="brand-text text-center">
          <h2 class="main-heading-1-gradient">Aliff Industry affiliations</h2>

        </div>
        <b-row class="py-5">
          <b-col
            v-for="(card, index) in cardData"
            :key="index"
            md="4"
            sm="6"
            class="mb-4 text-center"
          >

            <img
              :src="card.img"
              alt="Card image"
              class="border-0 m-auto"
              :style="{ width: index === 7 ? '300px' : '200px' }"
            />
          </b-col>
        </b-row>
      </div>
    </section> -->
    <section class="py-5">
      <div class="container">
        <div class="partnership-text text-center">
          <h2 class="main-heading-1-gradient text-center mb-2">
            Expanding Our Partnerships
          </h2>
          <!-- <p>
            A line to speak about featured destination, programme, or
            university.
          </p> -->
        </div>
        <b-row class="align-items-center row-cols-1 row-cols-lg-2 py-4">
          <b-col class="text-center text-lg-left">
            <img src="../../assets/imgs/map-a-one.png" alt="" class="img-fluid" />
          </b-col>
          <b-col class="text-center text-lg-right">
            <img src="../../assets/imgs/map-a-two.png" alt="" class="img-fluid" />
          </b-col>
        </b-row>
      </div>
    </section>
    <section class="py-5">
      <div class="container">
        <div class="text-center">
          <h2 class="">University Testimonials</h2>
          <!-- <p>
            A line to speak about featured destination, programme, or
            university. A line to speak about featured destination, programme,
            or university
          </p> -->
        </div>
        <b-row class="py-5 row-cols-1 row-cols-md-2 row-cols-lg-3">
          <b-col v-for="(card, index) in car_test" :key="'a' + index" class="px-5">
            <div class="">
              <img :src="card.img" alt="" class="img-fluid mb-2 uni-img" />

              <h5 class="font-bold">{{ card.title }}</h5>
              <p style="font-size: 14px !important">{{ card.para }}</p>
              <p class="text-center">{{ card.country }}</p>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
    <!-- <section>
      <b-row class="d-flex justify-content-center m-0">
        <div style="height: 800px; width: 100%">
          <img
            src="../../assets/imgs/AI-powered.png"
            alt=""
            class="img-fluid"
            style="object-fit: contain; height: 100%; width: 100%"
          />
        </div>
      </b-row>
    </section> -->

    <!-- NPF Form -->
    <!-- <section
      class="border d-flex flex-column align-items-center justify-content-center"
      style="height: 700px"
    >
      <h2 class="text-center py-5">Associate Form</h2>
      <div class="container">
        <form @submit.prevent="handleSubmit">
          <div class="custom-form-control row">
            <div class="col-6 mb-1">
              <div class="form-spacing">
                <label>Name:</label>
                <input
                  size="sm"
                  required
                  v-model="form.name"
                  placeholder="Enter Name *"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-6 mb-1">
              <div class="form-spacing">
                <label>Email:</label>
                <input
                  required
                  size="sm"
                  v-model="form.email"
                  placeholder="Enter Email Address *"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-4 mb-1">
              <div class="form-spacing">
                <label>Phone Number:</label>
                <input
                  required
                  size="sm"
                  v-model="form.mobileNumber"
                  placeholder="Enter Mobile Number *"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-4 mb-1">
              <label>Select State:</label>

              <b-form-select
                required
                size="sm"
                v-model="form.state"
                :options="stateOptions"
                class="form-control"
              ></b-form-select>
            </div>
            <div class="col-4 mb-1">
              <label>Select City:</label>

              <b-form-select
                required
                size="sm"
                v-model="form.city"
                :options="cityOptions"
                class="form-control"
              ></b-form-select>
            </div>
          </div>
        </form>
      </div>
    </section> -->
    <div class="w-100 py-5 d-flex justify-content-center mb-1">
      <a href="#newForm" type="submit" class="btn rounded w-50" style="background-color: #fe6d01; color: white">
        Enquire Now
      </a>
    </div>

    <!-- <section class="py-5">
      <div class="container">
        <h2 class="main-heading-1-gradient text-center">Board Of Advisors</h2>

        <div class="row justify-content-center"> -->
    <!-- Neeraj Shah -->
    <!-- <div class="col-12 col-md-6 col-lg-3">
            <div class=" text-center">
              <img src="@/assets/imgs/neeraj shah.png" alt="" />
              <h4 class="bold">Neeraj Shah</h4>
              <h6
                style="color: #2A9CCE;font-weight: 600;"
                class="text-capitalize"
              >
                Alumni Merchant Taylor's School &amp; Univ of Bath - UK Ex
                Co-National Director - BNI India
              </h6>
            </div>
          </div> -->

    <!-- Mansoor Khan -->
    <!-- <div class="col-12 col-md-6 col-lg-3">
            <div class=" text-center">
              <img src="@/assets/imgs/mansoor khan.png" alt="" />
              <h4 class="bold">Mansoor Khan</h4>
              <h6
                style="color: #2A9CCE;font-weight: 600;"
                class="text-capitalize"
              >
                Founder Director - AMFAH INDIA Regional Product Manager - BPL
                Limited
              </h6>
            </div>
          </div> -->

    <!-- Zafar Khan -->
    <!-- <div class="col-12 col-md-6 col-lg-3">
            <div class=" text-center">
              <img src="@/assets/imgs/zafar-khan.png" alt="" />
              <h4 class="bold">Zafar Khan</h4>
              <h6
                style="color: #2A9CCE;font-weight: 600;"
                class="text-capitalize"
              >
                Founding Consultant Jetking Infotrain Ltd. <br />
                Ex Managing Partner Jawed Habib HairXpreso
              </h6>
            </div>
          </div> -->

    <!-- Himanshu Dev -->
    <!-- <div class="col-12 col-md-6 col-lg-3">
            <div class=" text-center">
              <img src="@/assets/imgs/himanshu dev.png" alt="" />
              <h4 class="bold">Himanshu Dev</h4>
              <h6
                style="color: #2A9CCE;font-weight: 600;"
                class="text-capitalize"
              >
                Alumni &amp; Ex Lecturer North Caroline State Univ., USA
                Education Advisor - USA High Commission
              </h6>
            </div>
          </div> -->

    <!-- Dr. Sanjay Kantharia -->
    <!-- <div class="col-12 col-md-6 col-lg-3">
            <div class=" text-center p-2">
              <img class="" src="@/assets/imgs/boa-5.png" alt="" />
              <h4 class="bold mt-4">Dr. Sanjay Kantharia</h4>
              <h6
                style="color: #2A9CCE;font-weight: 600;"
                class="text-capitalize"
              >
                MBBS & MS Orthopaedic from KEM
              </h6>
            </div>
          </div> -->

    <!-- Dr. Abdelkhalig Osman Mohamed -->
    <!-- <div class="col-12 col-md-6 col-lg-3">
            <div class=" text-center">
              <img
                class="boa-img mt-3"
                src="@/assets/imgs/boa-6-modified.png"
                alt=""
              />
              <h5 class="bold mt-4">Dr. Abdelkhalig Osman Mohamed</h5>
              <h6
                style="color: #2A9CCE;font-weight: 600;"
                class="text-capitalize"
              >
                CEO of Gulf conference ltd, London, UK.<br />
              </h6>
            </div>
          </div>
        </div> -->
    <!-- </div> -->
    <!-- </section> -->
    <!-- <section class="founder-section section-spacing">
      <div class="container"> -->
    <!-- <div class="row"> -->
    <!-- <div class="col-lg"> -->
    <!-- <div> -->
    <!-- <h2 class="main-heading-1-gradient text-center">About the Founder</h2> -->
    <!-- </div> -->
    <!-- </div> -->
    <!-- </div> -->
    <!-- <div class="row mt-5 align-items-center">
          <div class="col-lg-4 responsive-img">
            <img
              src="@/assets/imgs/about-image.png"
              class="img-fluid border-20"
            />
          </div>
          <div class="col-lg-8 founder-intro">
            <h4 class="font-weight-bold">Mr. Asslam Shaikh</h4>
            <h6 class="primary-color pt-2">Founder & CEO</h6>
            <p class="main-content-1 pt-3">
              Asslam I Shaikh Mr Asslam is a young edupreneur. He has over a
              decade of experience in the field of education & has travelled to
              over 14 countries. He was listed among Top 10 Best Consulting
              Leaders by Knowledge Review & Won ‘Genius’ award by Times
              Education. He is a certified Global consultant by ICEF Germany &
              British Council.
              <br /><br />
              <i
                >“My passion is to help ambitious students to join top-ranking
                international universities so that they can easily earn 6 figure
                salaries without wasting time or spending a fortune & worrying
                about their marks"</i
              >
            </p>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import card1 from "../../assets/imgs/a-icons/Clock.png";
import card2 from "../../assets/imgs/a-icons/Support.png";
import card3 from "../../assets/imgs/a-icons/Hand.png";
import card4 from "../../assets/imgs/a-icons/Updated.png";
import card5 from "../../assets/imgs/a-icons/Data_Management.png";
import card6 from "../../assets/imgs/a-icons/Check.png";
import AssociateTestimonial from "@/components/partials/AssociateTestimonial.vue";
import homeServices from "@/apiServices/homeServices";
import brandImg1 from "../../assets/imgs/affiliate-1.png";
import brandImg2 from "../../assets/imgs/affiliate-2.png";
import brandImg3 from "../../assets/imgs/affiliate-3.png";
import brandImg4 from "../../assets/imgs/image 30.png";
import brandImg5 from "../../assets/imgs/affiliate-4.png";
import brandImg6 from "../../assets/imgs/affiliate-5.png";
import brandImg7 from "../../assets/imgs/affiliate-6.png";
import brandImg8 from "../../assets/imgs/affiliate-7.png";
import brandImg9 from "../../assets/imgs/affiliate-8.png";
import board1 from "@/assets/imgs/board-1.png";
import slide1 from "@/assets/imgs/ass-test-1.png";
import slide2 from "@/assets/imgs/ass-test-2.png";
import slide3 from "@/assets/imgs/ass-text-3.png";
import flag1 from "../../assets/imgs/franchise-countries/flag-1.png";
import flag2 from "../../assets/imgs/franchise-countries/flag-2.png";
import flag3 from "../../assets/imgs/franchise-countries/flag-3.png";
import flag4 from "../../assets/imgs/franchise-countries/flag-4.png";
import flag6 from "../../assets/imgs/franchise-countries/flag-6.png";
import flag7 from "../../assets/imgs/franchise-countries/flag-7.png";
import {
  stateOptions,
  courseOptions,
  specializationOptions,
  cityOptions,
} from "../partials/sefDetails";
import { IMAGEURL } from "@/config";

export default {
  components: {
    AssociateTestimonial,
  },

  data() {
    return {
      IMAGEURL,
      stateOptions,
      courseOptions,
      specializationOptions,
      cityOptions,
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      },

      cards: [
        {
          preText: "Quick",
          title: "Offer letter",
          postText: "in 6 days",
          image: card1,
        },
        {
          preText: "Instant",
          title: "Response",
          postText: "within 10 minutes",
          image: card2,
        },
        {
          preText: "On Time",
          title: "Commission",
          postText: "fair calculation",
          image: card3,
        },
        {
          preText: "Regular",
          title: "Updates",
          postText: "& Training",
          image: card4,
        },
        {
          preText: "Hi-tech platform",
          title: "Automate",
          postText: "full process",
          image: card5,
        },
        {
          preText: "Diverse",
          title: "Portfolio",
          postText: "75k+ courses",
          image: card6,
        },
      ],
      cardData: [
        { img: brandImg1 },
        { img: brandImg2 },
        { img: brandImg3 },
        { img: brandImg4 },
        { img: brandImg5 },
        { img: brandImg6 },
        { img: brandImg7 },
        { img: brandImg8 },
        { img: brandImg9 },
      ],
      mydata: [
        {
          title: "Platinum",
          service_fee: "₹1,63,000",
          discount: "15%",
          plan: "preferred plan",
          gst: " ₹80,750",
          rzp_link: "https://app.aliff.in/services",
          color: "#2A9CCE",
          btn_color: "linear-gradient(90deg, #5367FF 0%, #00D09C 100%);",
          bullet_points: [
            "SAT",
            "Time management",
            "Recommendation letter",
            "Sessions that makes you winner in life.",
          ],
        },
        {
          title: "Gold",
          service_fee: "₹1,63,000",
          discount: "30%",
          plan: "preferred plan",
          gst: " ₹35,000",
          rzp_link: "https://app.aliff.in/services",
          color: "#FF7A00",
          btn_color:
            "linear-gradient(90deg, #FF7A00 0%, #FF3D00 100%),linear-gradient(0deg, #FFA132, #FFA132);",
          bullet_points: [
            "SAT",
            "Time management",
            "Recommendation letter",
            "Sessions that makes you winner in life.",
          ],
        },
        {
          title: "Silver",
          service_fee: "₹1,63,000",
          discount: "30%",
          plan: "preferred plan",
          gst: " ₹8,750",
          rzp_link: "https://app.aliff.in/services",
          color: "#2A9CCE",
          btn_color: "linear-gradient(90deg, #5367FF 0%, #00D09C 100%);",
          bullet_points: [
            "SAT",
            "Time management",
            "Recommendation letter",
            "Sessions that makes you winner in life.",
          ],
        },
      ],
      featured_universities: [],
      logoSlider: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
      board: [
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
        { img: board1, name: "Neeraj shah", designation: "designation" },
      ],
      programs: [
        { title: "Engineering", color: "#5366FF" },
        { title: "Business / Management", color: "#00D09C" },
        { title: "Computer & IT Related", color: "#FFDE58" },
        { title: "Arts & Designs", color: "#A6A6A6" },
        { title: "MBBS (Health & Science)", color: "#FF904D" },
        {
          title: "Others...Phsycology, Law, Sports Etc",
          color: "#E8C7BC",
        },
      ],
      slide: 0,
      sliding: null,
      car_test: [
        {
          img: slide1,
          title: "Among Top 203 - US News",
          para: "Aliff has been consistently engaged in helping us explore new markets and continue to bean excellent partner, helping usmeet our enrolment goals.",
          country: "USA",
        },
        {
          img: slide2,
          title: "Among Top 260 - QS Ranking",
          para: "Aliff has done some really good work in the undergraduate space and we cherish our relationship with them. The team does a great job in connecting us to high values students.",
          country: "New Zealand",
        },
        {
          img: slide3,
          title: "Among Top 295 - QS Ranking",
          para: "We found Aliff team to be professional and transparent in all interaction with the university.The quality and suitability of students has been of a high standard.",
          country: "Ireland",
        },
      ],
      countries: [
        {
          Country: "United States of America",
          text1: "6L",
          Fee: "6L",
          text2: "100% Accom Grant",
          Internship: null,
          Scholarship: null,
          Ranking: null,
          Entry: null,
          Language: null,
          WorkPermit: null,
          Image: flag1,
        },
        {
          Country: "United Kingdom",
          Fee: null,
          Accommodation: null,
          text1: "Paid Internship",
          text2: "upto 50% Scholarship",
          Ranking: null,
          Entry: null,
          Language: null,
          WorkPermit: null,
          Image: flag2,
        },
        {
          Country: "Europe",
          text1: "3L",
          Accommodation: null,
          Internship: null,
          Scholarship: null,
          text2: "Top 500 QS Ranking Unis",
          Entry: null,
          Language: null,
          WorkPermit: null,
          Image: flag6,
        },
        {
          Country: "Canada",
          Fee: null,
          Accommodation: null,
          Internship: null,
          text2: "upto 25% Scholarship",
          Ranking: null,
          text1: "Direct MBA entry",
          Language: null,
          WorkPermit: null,
          Image: flag3,
        },
        {
          Country: "Germany",
          Fee: null,
          Accommodation: null,
          Internship: null,
          text2: "upto 100% Scholarship",
          Ranking: null,
          Entry: null,
          text1: "Study in English",
          WorkPermit: null,
          Image: flag4,
        },
        {
          Country: "Ireland",
          Fee: null,
          text2: "100% Accom Grant",
          Internship: null,
          Scholarship: null,
          Ranking: null,
          Entry: null,
          Language: null,
          text1: "2 Yrs Work Permit",
          Image: flag7,
        },
      ],
    };
  },
  methods: {
    formSubmitToast() {
      this.$bvToast.toast(`The form has been submitted successfully.`, {
        title: "Form Submitted",
        autoHideDelay: 5000,
        solid: true,
      });
    },
    async handleSubmit(e) {
      try {
        e.preventDefault();

        const requestData = {
          name: this.form.name,
          email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.form.mobileNumber,
          source: `associate-${this.form.state}-${this.form.city}`,
          state: this.form.state,
          city: this.form.city,
        };

        const response = await homeServices.saveSef(requestData);

        if (response.data.status) {
          this.resetForm();
          this.formSubmitToast();
        }

        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
    getButtonClass(title) {
      switch (title.toLowerCase()) {
        case "platinum":
          return "btn-platinum";
        case "gold":
          return "btn-gold";
        case "silver":
          return "btn-silver";
        default:
          return ""; // Default or fallback class
      }
    },
    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      };
    },
    async getData() {
      try {
        const featured_universities =
          await homeServices.getFeaturedUniversities();
        if (featured_universities.data.status) {
          const data = featured_universities.data.data;
          let temp_arr = [];
          let i = 0;
          while (i < data.length) {
            let arr = [];
            arr.push(data[i]);
            arr.push(data[i + 1]);
            arr.push(data[i + 2]);
            temp_arr.push(arr);
            i = i + 3;
          }
          this.featured_universities = temp_arr;
        }
      } catch (err) {
        console.log("Error in getting data ", err);
      }
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>
<style>
.full-wrapper {
  font-family: Fira Sans;
  margin: 10rem 0;
}

.a-hero-text h2 {
  font-family: Fira Sans;
  font-size: 70px;
  font-weight: 500;
  line-height: 84px;
  letter-spacing: 0em;
  text-align: center;
}

.a-card {
  box-shadow: 3.2259058952331543px 4.838858604431152px 12.903623580932617px 0px #14253f1f;
  border-radius: 15px;
  min-height: 375px;
  height: fit-content;
}

.btn-platinum {
  background: linear-gradient(90deg, #5367ff 0%, #00d09c 100%);
}

.btn-gold {
  background: linear-gradient(90deg, #ff7a00 0%, #ff3d00 100%),
    linear-gradient(0deg, #ffa132, #ffa132);
}

.btn-silver {
  background: linear-gradient(90deg, #5367ff 0%, #00d09c 100%);
}

.logo-card {
  box-shadow: -4px -4px 4px rgba(255, 255, 255, 0.13),
    4px 4px 11px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  padding: 10px;
  margin: 10px;
  cursor: pointer;
  overflow: hidden !important;
}

.logo-img img {
  height: 80px;
  width: 200px;
  object-fit: contain;
  align-items: center;
  display: flex;
  justify-content: center;
}

.content {
  padding: 1rem 2rem 0rem 2rem !important;
  width: max-content;
}

.content p {
  width: max-content;
  margin: auto;
}

.state-list {
  padding-left: 64px;
}

.dy-color {
  width: 40px;
  height: 40px;
  border-radius: 10px;
}

.b-car-bg {
  background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%);
}

.custom-input {
  border: none;
  outline: 0 !important;
  border-bottom: 1px solid lightgrey;
  box-shadow: none;
  transition: all 0.5s;
}

.custom-input:focus {
  box-shadow: none !important;
  border-bottom: 1px solid #fe6d01;
}

.uni-img {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AssociatePage.vue